
import i18n from '@/i18n/index'

const billsManager = [
  {
    path: '/billsManager',
    component: () => import('@/views/billsManager/index.vue'),
    meta: { name: i18n.t('menu.billsManager'), allowBreadcrumbRedirect: true },
    redirect: {
      name: 'billsManagerList'
    },
    children: [
      // 账期
      {
        // 列表
        path: 'list',
        name: 'billsManagerList',
        component: () => import('@/views/billsManager/bill/list/index.vue'),
        meta: { name: i18n.t('text.list'), keepAlive: true }
      },
      {
        // 新增
        path: 'add',
        name: 'billsManagerAdd',
        component: () => import('@/views/billsManager/bill/add/index.vue'),
        meta: { name: i18n.t('text.add'), keepAlive: false  }
      },
      {
        // 编辑
        path: 'edit/:id',
        name: 'billsManagerEdit',
        component: () => import('@/views/billsManager/bill/add/index.vue'),
        meta: { name: i18n.t('text.edit'), keepAlive: false  }
      },
      {
        // 详情
        path: 'detail/:id',
        name: 'billsManagerDetail',
        component: () => import('@/views/billsManager/bill/detail/index.vue'),
        meta: { name: i18n.t('text.detail'), keepAlive: false  }
      }
    ]
  }
]

export default billsManager
